import { FormsFieldPreset, FormPlugin } from '@wix/forms-common'
import { GeneralDatePicker } from '../../general-fields/definitions/general-date-picker'
import { CRM_TYPES } from '../../../../../../constants/crm-types-tags'
import { CATEGORIES } from '../../../../../../panels/manage-fields-panel/constants/manage-fields-constants'

export class Birthday extends GeneralDatePicker {
  public get customFields() {
    return this.base.customFields
  }

  public get fieldType() {
    return FormsFieldPreset.BIRTHDAY
  }

  // birthday field in server is calling birthdate
  public get crmType() {
    return CRM_TYPES.BIRTHDATE
  }

  protected get data(): any {
    return { placeholder: this.translate(`fieldTypes.${this.fieldType}`) }
  }
  protected get renderConfig() {
    return {
      [FormPlugin.FORM_BUILDER]: {
        addFieldPanelData: {
          category: CATEGORIES.contact,
        },
      },
      [FormPlugin.REGISTRATION_FORM]: {
        addFieldPanelData: { category: CATEGORIES.none },
      },
    }
  }
}
